import React from "react";
import { makeStyles } from "@material-ui/core";
import clsx from "clsx";
export default ({ color, className, style }) => {
    const classes = useStyles({ color });
    return (React.createElement("div", { className: clsx(classes.root, className), style: style },
        React.createElement("div", { className: classes.dot }),
        React.createElement("div", { className: classes.dot }),
        React.createElement("div", { className: classes.dot })));
};
const useStyles = makeStyles((theme) => ({
    dot: ({ color = "inherit" }) => ({
        backgroundColor: color !== "inherit" ? theme.palette.loader[color] : "inherit",
    }),
    root: {
        display: "grid",
        gridTemplateColumns: "repeat(3,1fr)",
        gridGap: 3,
        maxWidth: 24,
        "& $dot": {
            animation: "$dots 1.5s infinite ease-in-out",
            borderRadius: "50%",
            display: "inline-block",
            height: "6px",
            width: "6px",
            transformOrigin: "center",
            "&:nth-child(2)": {
                animationDelay: ".5s",
            },
            "&:nth-child(3)": {
                animationDelay: "1s",
            },
        },
    },
    "@keyframes dots": {
        "0%": {
            opacity: 0.4,
            transform: "scale(1, 1)",
        },
        "50%": {
            opacity: 1,
            transform: "scale(1.2, 1.2)",
        },
        "100%": {
            opacity: 0.4,
            transform: "scale(1, 1)",
        },
    },
}));
//# sourceMappingURL=FTLDots.js.map